var map = {
	"./BAND.webp": 7864,
	"./Badminton.webp": 5597,
	"./IPA.webp": 9894,
	"./MD.webp": 3373,
	"./MUN.webp": 5947,
	"./Matematika.webp": 3534,
	"./Mural.webp": 116,
	"./Voli.webp": 3064,
	"./basket.webp": 3148,
	"./business-plan.webp": 7403,
	"./eds.webp": 1510,
	"./fotografi.webp": 8389,
	"./futsal.webp": 2275,
	"./ips.webp": 3266,
	"./shortmovie.webp": 9206,
	"./speech.webp": 6140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1466;